import consts from "shared/consts";
import { NodeDrawProps } from "./types";

export const CurrentAnchorMode: "center" | "topleft" = "topleft";
export const TextFieldHeight = 15;
export const SeparationLayers = 100;
export const DragDropThreshold = 200 * 200;
export const SeparationSiblings = 1.5;
export const DefaultNodeStyle: NodeDrawProps = { lineWidth: 2, dash: 0, color: consts.ORG_CHART_COLOR_PALETTE[5] };
